export const color = {
  moderate: "#FFA500",
  green: "#6BC87F",
  red: "#ff0000",
  default: "#000000"
};
